import React from "react"

import "./ShareLinks.scss"

import { IconShare } from "@ui/Icon"

const ShareLinks: React.FC<{share: Quiz.Api.ShareLinks}> = ({share}) => {
  return (
    <div className="neo__quizShare">
      <a className="neo__quizShare__facebook" href={share.facebook} target="_blank" rel="noreferrer"><div><IconShare shareType="facebook" /></div><span>Facebook</span></a>
      <a className="neo__quizShare__twitter" href={share.twitter} target="_blank" rel="noreferrer"><div><IconShare shareType="twitter" /></div><span>Twitter</span></a>
      <a className="neo__quizShare__whatsapp" href={share.whatsapp} target="_blank" rel="noreferrer"><div><IconShare shareType="whatsapp" /></div><span>WhatsApp</span></a>
      <a className="neo__quizShare__mail" href={share.mail} target="_blank" rel="noreferrer"><div><IconShare shareType="mail" /></div><span>E-Mail</span></a>
    </div>
  )
}

export default ShareLinks
